"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        // These two interface names match data contract class names defined in the kernel
        var ReliableChannel = /** @class */ (function () {
            function ReliableChannel(channelId) {
                /**
                 * True when there is an outstanding server request
                 */
                this.pendingResponse = false;
                /**
                 * True when an oustanding server request could affect ability to save
                 */
                this.pendingResponseCouldAffectSave = false;
                this.channelId = channelId || 0;
                this.serverSessionId = null;
                this.lastServerAcknowledgedSequenceNumber = 0;
                this.lastServerProcessedSequenceNumber = 0;
                this.nextClientSequenceNumber = 0;
                this.inboundMessages = [];
                this.outboundMessages = [];
                this.sendWhenReceiveResponse = false;
                this.interactionReceived = new $dyn.eventHost();
                this.errorReceived = new $dyn.eventHost();
                this.interactionSent = new $dyn.eventHost();
                var user = $dyn.user();
                if (user) {
                    this.partition = user.RequestPartition;
                    this.company = user.Company;
                    this.language = user.Language;
                }
            }
            ReliableChannel.prototype.hasPendingResponse = function (onlyDataAffectingInteractions) {
                var e_1, _a, e_2, _b;
                if (onlyDataAffectingInteractions === void 0) { onlyDataAffectingInteractions = false; }
                var retVal = false;
                if (this.pendingResponse && (!onlyDataAffectingInteractions || this.pendingResponseCouldAffectSave)) {
                    retVal = true;
                }
                else if (this.serverRequestQueued) {
                    if (onlyDataAffectingInteractions) {
                        if (this.outboundMessages) {
                            try {
                                for (var _c = __values(this.outboundMessages), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var message = _d.value;
                                    if (message && message.Interactions) {
                                        try {
                                            for (var _e = (e_2 = void 0, __values(message.Interactions)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                                var interaction = _f.value;
                                                if ($dyn.serverForm.couldInteractionAffectSave(interaction)) {
                                                    retVal = true;
                                                    break;
                                                }
                                            }
                                        }
                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                        finally {
                                            try {
                                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                        }
                                    }
                                    if (retVal) {
                                        break;
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                    }
                    else {
                        retVal = true;
                    }
                }
                return retVal;
            };
            /**
             * Enqueues a set of interactions to be sent to the client.
             * @param interactions Interactions to be sent to client.
             * @param windowId The windowId to be associated with this set of interactions.
             * @param processImmediate Used to determine whether or not to batch interactions queued in the same event loop.
             */
            ReliableChannel.prototype.sendInteractions = function (interactions, windowId, processImmediate) {
                var _this = this;
                if (interactions && interactions.length > 0) {
                    var message = {
                        // __type: $dyn.serverForm.MessageType.reliableMessage,
                        Interactions: interactions,
                        SequenceNumber: ++this.nextClientSequenceNumber,
                    };
                    var givePriority = interactions.some(function (interaction) {
                        return interaction.PriorityPosition;
                    });
                    if (givePriority) {
                        if (this.outboundMessages.length > 0) {
                            var firstUsedSequenceNumber = this.outboundMessages[0].SequenceNumber;
                            message.SequenceNumber = firstUsedSequenceNumber;
                            this.outboundMessages.unshift(message);
                            for (var i = 1; i < this.outboundMessages.length; i++) {
                                this.outboundMessages[i].SequenceNumber = firstUsedSequenceNumber + i;
                            }
                        }
                        else {
                            this.outboundMessages.push(message);
                        }
                    }
                    else {
                        this.outboundMessages.push(message);
                    }
                }
                if (this.outboundMessages.length > 0) {
                    if (this._currentRequest != null) {
                        // there is already an ongoing request
                        this.sendWhenReceiveResponse = true;
                        // Set the currentWindowId so the interactions in the queue are mapped to the right window when the current request returns.
                        $dyn.log.server &&
                            $dyn.log.server("ReliableChannel: Channel " +
                                this.channelId +
                                " updating currentWindowId from " +
                                this.currentWindowId +
                                " to " +
                                windowId +
                                " in function sendInteractions.  _currentRequest != null");
                        this.currentWindowId = windowId;
                    }
                    else {
                        this.sendWhenReceiveResponse = false;
                        var _sendInteractions_1 = function () {
                            // In the case where there was no ongoing request that blocked the initial send of interactions, we set the currentWindowId to be the passed windowId.
                            // Otherwise we entered sendInteractions via an ajax success callback (with interactions==null) and want to just use the saved currentWindowId.
                            // If windowId is undefined, then the interactions will be assumed for the Host window.
                            // The stringify of the request that occurs before sending to the server removes undefined properties.
                            if (interactions != null && _this.currentWindowId !== windowId) {
                                $dyn.log.server &&
                                    $dyn.log.server("ReliableChannel: Channel " + _this.channelId + " updating currentWindowId from " + _this.currentWindowId + " to " + windowId + " in function sendInteractions.");
                                _this.currentWindowId = windowId;
                            }
                            var companyId;
                            var language;
                            var partition;
                            if (_this.company) {
                                companyId = _this.company();
                            }
                            if (_this.language) {
                                language = _this.language();
                            }
                            if (_this.partition) {
                                partition = _this.partition();
                            }
                            var request = {
                                ChannelId: _this.channelId,
                                CompanyId: companyId,
                                Language: language,
                                LastAcknowledgedSequenceNumber: _this.lastServerProcessedSequenceNumber,
                                Messages: _this.outboundMessages,
                                Partition: partition,
                                WindowId: _this.currentWindowId,
                            };
                            // Send the interactions to the server;
                            _this._currentRequest = _this.beginRequest(request);
                        };
                        if (processImmediate) {
                            // Send the interactions immediately so that they don't batch with others that might be sent in the same event loop.
                            // Primary consume of this flag is the case where interactions are sitting in the queue and interactions from a different window try to enqueue.
                            // The previous interactions need to flush immediately to make room for the incoming interactions so that their windowId's don't overwrite each other.
                            _sendInteractions_1();
                        }
                        else {
                            // Delay the calling of beginRequest.
                            // If there is already a request queued up, then ignore the rest of the requests in the same event loop.
                            if (!this.serverRequestQueued) {
                                var beginSendInteractions_1 = function () {
                                    return $dyn.async(function () {
                                        if (!$dyn.peek($dyn.shell.extendedEventLoopOn)) {
                                            _this.serverRequestQueued = undefined;
                                            _sendInteractions_1();
                                        }
                                        else {
                                            $dyn.async.pending.increment("extendedEventLoopOn");
                                            $dyn.observe($dyn.shell.extendedEventLoopOn, function (eventLoopOn) {
                                                if (!eventLoopOn) {
                                                    $dyn.async.pending.decrement("extendedEventLoopOn");
                                                    _this.serverRequestQueued = beginSendInteractions_1();
                                                    return false;
                                                }
                                            });
                                        }
                                    }, undefined, "Delay server request");
                                };
                                this.serverRequestQueued = beginSendInteractions_1();
                            }
                            else {
                                $dyn.log.server && $dyn.log.server("ReliableChannel: Ignoring requests to sendInteractions in the same event loop. WindowId: " + windowId + " Interactions: " + interactions);
                            }
                        }
                    }
                }
            };
            ReliableChannel.prototype.beginRequest = function (data, retrying) {
                var e_3, _a, e_4, _b;
                var _this = this;
                /**
                 * Provides a location where we can retry the request based on current client configuration before we give up and show error to user.
                 */
                var preError = function (response, textStatus, error) {
                    _this._preError(response, textStatus, error, data, retrying);
                };
                var _headers = {};
                if (retrying) {
                    _headers[$dyn.serverForm.RequestHeaderKeys.sessionWaitTimeout] = $dyn.serverForm.sessionWaitTimeoutOnRetry.toString();
                }
                // tslint:disable:object-literal-sort-keys
                var options = {
                    data: JSON.stringify(data),
                    url: $dyn.serverForm.ReliableChannel.serviceAddress + "?",
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: this._preSuccess.bind(this),
                    error: preError,
                    beforeSend: this._beforeSend.bind(this),
                    // tslint:disable-next-line:triple-equals
                    timeout: this.serverSessionId == null ? $dyn.serverForm.sessionInitiationTimeout : $dyn.serverForm.sessionRequestTimeout,
                    headers: _headers,
                };
                // tslint:enable:object-literal-sort-keys
                // Append the company, partition and language if present
                // this should be removed and pulled from the message body
                // once we refactor the session code in the service
                if (data.CompanyId) {
                    options.url += "cmp=" + encodeURIComponent(data.CompanyId) + "&";
                }
                if (data.Language) {
                    options.url += "lng=" + encodeURIComponent(data.Language) + "&";
                }
                if (data.Partition) {
                    options.url += "prt=" + encodeURIComponent(data.Partition);
                }
                // Capture the last and initial start times of the request to know how long
                // the current attempt took and how long we've been trying to get this payload processed
                this._lastStartTime = window.performance.now();
                if (!this._initialStartTime) {
                    this._initialStartTime = this._lastStartTime;
                }
                this._serverRequestTask && this._serverRequestTask.start();
                $dyn.async.pending.increment("begin request");
                this.pendingResponse = true;
                this.pendingResponseCouldAffectSave = false;
                if (data && data.Messages) {
                    try {
                        for (var _c = __values(data.Messages), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var message = _d.value;
                            if (message && message.Interactions) {
                                try {
                                    for (var _e = (e_4 = void 0, __values(message.Interactions)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                        var interaction = _f.value;
                                        if ($dyn.serverForm.couldInteractionAffectSave(interaction)) {
                                            this.pendingResponseCouldAffectSave = true;
                                            break;
                                        }
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                            }
                            if (this.pendingResponseCouldAffectSave) {
                                break;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
                // Initiate the ajax request
                var rv = $dyn.ajax(options);
                if (!$dyn.flags.disablePing && !$dyn.flags.fromVS) {
                    // Reset ping
                    $dyn.serverForm.pingReset();
                }
                // Notify listeners
                this.interactionSent.raise({ Channel: this, Data: data });
                return rv;
            };
            /**
             * Handles received messages
             * @param messages Received messages
             */
            ReliableChannel.prototype.receiveMessages = function (messages) {
                if (!messages) {
                    // The success handler was called with a null message set,
                    // make the channel retry sending the messages in the outbound message queue
                    this.sendWhenReceiveResponse = true;
                    $dyn.logError("$dyn.serverForm.ReliableChannel.receiveMessages: Success callback fired with a null message set");
                    return;
                }
                $dyn.assert(messages.ChannelId === this.channelId, "Message got routed to the wrong channel.");
                // A list of callbacks to be processed after processing inbound interactions
                var interactionCallbacks = [];
                // Compare the last acknowledgment from client with the one the server has
                if (messages.LastAcknowledgedSequenceNumber > this.lastServerAcknowledgedSequenceNumber) {
                    this.lastServerAcknowledgedSequenceNumber = messages.LastAcknowledgedSequenceNumber;
                    // Update the outbound queue to remove already acknowledged messages
                    interactionCallbacks = this._updateOutboundQueue();
                }
                // Push the messages into the inbound queue
                for (var i = 0, len = messages.Messages.length; i < len; i++) {
                    var message = messages.Messages[i];
                    if (message == null) {
                        continue;
                    }
                    // Check if we have already handled this message
                    if (this.lastServerProcessedSequenceNumber >= message.SequenceNumber) {
                        // We have already handled this message.
                        // The client must have not received our acknowledgment yet.
                        continue;
                    }
                    // Add the message to the inbound queue.
                    this._addToInboundQueue(message);
                }
                // Inbound and Outbound queues are now ready. let's start processing the messages.
                // Process messages
                this._processInboundMessages(messages.WindowId);
                if (this._isChannelBlocking) {
                    $dyn.serverForm.interactionManager.decrementGlobalBlockingFlag();
                    this._isChannelBlocking = false;
                }
                // Process command callbacks
                for (var i = 0, len = interactionCallbacks.length; i < len; i++) {
                    interactionCallbacks[i].completeCommand && interactionCallbacks[i].completeCommand();
                    interactionCallbacks[i].decrementWindowAsyncPending && interactionCallbacks[i].decrementWindowAsyncPending();
                    if (interactionCallbacks[i].ShouldBlockOnExecution) {
                        $dyn.serverForm.interactionManager.decrementGlobalBlockingFlag();
                    }
                }
            };
            ReliableChannel.prototype._processInboundMessages = function (windowId) {
                if (this.inboundMessages.length > 0) {
                    while (this.inboundMessages.length > 0) {
                        // Get the first message in the inbound list
                        var message = this.inboundMessages[0];
                        // the sequence numbers must be next to the last processed one otherwise
                        // there is a gap in the inbound message queue.
                        if (message.SequenceNumber !== this.lastServerProcessedSequenceNumber + 1) {
                            // We are missing a message in the queue, stop processing until the
                            // missing messages are received
                            break;
                        }
                        // Adjust the last process message sequence number
                        this.lastServerProcessedSequenceNumber = message.SequenceNumber;
                        // Remove the item from the list. We are using the list as a Queue in here. The reason
                        // why we are not using it as a queue because we need to insert messages inside if they
                        // arrive out of order.
                        // Pops the first item
                        this.inboundMessages.shift();
                        this.interactionReceived.raise({ Channel: this, Interactions: message.Interactions, WindowId: windowId });
                    }
                }
                else {
                    // Raise interactionReceived even for the case with no messages, so commands without callback still trigger any listeners.
                    this.interactionReceived.raise({ Channel: this, Interactions: [], WindowId: windowId });
                }
            };
            /**
             * Delegate invoked before a request is sent to the server.
             * @param request Current request about to go to the server.
             */
            ReliableChannel.prototype._beforeSend = function (request) {
                // Add the session id value to header
                if (this.serverSessionId) {
                    request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.sessionKey, this.serverSessionId);
                }
                // Set the csrf token
                $dyn.serverForm.setCsrfToken(request);
                var activityKey = $dyn.util.newGuid();
                request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.activityKey, activityKey);
                $dyn.browserActivity.newInteraction(activityKey);
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax(activityKey);
            };
            /**
             * If pesudo-latency is enabled, handle the success callback only after a timeout
             */
            ReliableChannel.prototype._preSuccess = function (data, textStatus, request) {
                var _this = this;
                if ($dyn.ui.PerformanceTimer) {
                    $dyn.ui.PerformanceTimer._stopAjax();
                    $dyn.ui.PerformanceTimer._getRealTimeTrace && $dyn.ui.PerformanceTimer._getRealTimeTrace(request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.sessionLoggableKey));
                }
                this._serverRequestTask && this._serverRequestTask.stop();
                if (!$dyn.debug.latency) {
                    this._success(data, textStatus, request);
                }
                else {
                    // Try to parse the specified latency, defaulting to 150ms
                    var latency = 150;
                    if ($dyn.debug.latency !== true) {
                        latency = $dyn.debug.latency;
                    }
                    // Process success result after latency
                    $dyn.async(function () {
                        _this._success(data, textStatus, request);
                    }, latency, "Server request process success");
                }
            };
            /**
             * Delegate invoked upon success of the server request
             * @param data Response data
             * @param textStatus Request text status
             * @param request Request handle, can be used for querying Response headers
             */
            ReliableChannel.prototype._success = function (data, textStatus, request) {
                try {
                    this.pendingResponse = false;
                    var endTime = window.performance.now();
                    $dyn.log.server && $dyn.log.server("ServerForm: Request completed: %o", endTime - this._lastStartTime);
                    // Reset the currentRequest
                    this._currentRequest = null;
                    this._initialStartTime = null;
                    if (!request) {
                        // This shouldn't be null when using jQuery 1.4+
                        // todo localize error message
                        throw new Error("Invalid response event parameters.");
                    }
                    // Get the session id from the response
                    var returnedServerSessionId = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.sessionKey);
                    if (!returnedServerSessionId || !returnedServerSessionId) {
                        // Server must return a session id
                        // todo localize error message
                        throw new Error("Server didn't return a session id.");
                    }
                    // Get the fully qualified host name from the response
                    $dyn.browserActivity.TraceLogNodeName = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.hostNameKey);
                    $dyn.browserActivity.TraceLogNamespace = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.namespaceKey);
                    $dyn.browserActivity.TraceLogTenant = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.tenantKey);
                    $dyn.browserActivity.TraceLogRole = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.roleKey);
                    $dyn.browserActivity.aosId = request.getResponseHeader($dyn.serverForm.RequestHeaderKeys.aosId);
                    if (!this.serverSessionId) {
                        // Initialize the server session id from the response header
                        this.serverSessionId = returnedServerSessionId;
                    }
                    else {
                        // Compare session ids, they better match
                        if (this.serverSessionId !== returnedServerSessionId) {
                            // todo localize error message
                            throw new Error("Session id mismatch.");
                        }
                    }
                    // Get the response
                    var response = data;
                    // Handle the messages
                    this.receiveMessages(response);
                    // Check if there is any pending send
                    if (this.outboundMessages.length > 0 && this.sendWhenReceiveResponse) {
                        this.sendInteractions(null);
                    }
                }
                finally {
                    $dyn.async.pending.decrement("complete request (success)");
                    $dyn.telemetry.clearPersistentEventStorage();
                }
            };
            ReliableChannel.prototype._cleanupAfterRequestError = function () {
                if (this._isChannelBlocking) {
                    $dyn.serverForm.interactionManager.decrementGlobalBlockingFlag();
                    this._isChannelBlocking = false;
                }
                // Unblock the user interaction and restore focus
                $dyn.shell.forceUnBlockUserInteraction();
                // Notify the shell to set the isShellInitializing to false, which will allow layout and other things to run
                // that were postponed due to the splash screen and theme loading.
                $dyn.shell.isShellInitializing(false);
                // Reset the current request and its start time
                this._currentRequest = null;
                this._initialStartTime = null;
            };
            /**
             * Provides a location where we can retry the request based on current client configuration before we give up and show error to user.
             */
            ReliableChannel.prototype._preError = function (response, textStatus, error, data, retrying) {
                var _this = this;
                $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                if (!response) {
                    return;
                }
                // The request didn't get sent, the browser is most likely offline,
                // show a dialog that allows the user to retry manually until the issue is resolved
                if (textStatus !== "timeout" && response.readyState < 2) {
                    $dyn.telemetry.addCommunicationEvent(textStatus, response.status, $dyn.serverForm.retryTimeWhenIncompleteRequest, 0, $dyn.browserActivity.BrowserSessionActivity.Id, response.readyState);
                    if (window.performance.now() - this._initialStartTime < $dyn.serverForm.maxRetryTimeWhenIncompleteRequest) {
                        $dyn.async.pending.decrement("request failed (retrying)");
                        $dyn.async(function () {
                            _this._currentRequest = _this.beginRequest(data, true);
                        }, $dyn.serverForm.retryTimeWhenIncompleteRequest, "Server request retry on error");
                        return;
                    }
                    else {
                        // tslint:disable:object-literal-sort-keys
                        this._showConnectionErrorDialog({
                            ImageName: "Error",
                            Tooltip: $dyn.label("MessageBox_ErrorIcon"),
                            Text: $dyn.label("LostConnectionDialog_Message"),
                            RetryText: $dyn.label("LostConnectionDialog_RetryButtonText"),
                            Callback: function () {
                                if (!_this._isChannelBlocking) {
                                    $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: resending request after lost connection");
                                    _this._isChannelBlocking = true;
                                    $dyn.serverForm.interactionManager.incrementGlobalBlockingFlag(true, "showConnectionErrorDialog:lostConnection");
                                }
                                _this._currentRequest = _this.beginRequest(data, true);
                                $dyn.serverForm.interactionManager._isClientDisconnected = false;
                            },
                        });
                        // tslint:enable:object-literal-sort-keys
                        $dyn.serverForm.interactionManager._isClientDisconnected = true;
                        this._cleanupAfterRequestError();
                        $dyn.async.pending.decrement("request failed (offline)");
                        return;
                    }
                }
                // Handle errors that can be retried,
                // it's possible the reponse got dropped and never reached us
                // or the request never reached the server
                // HTTP status code 409 is used internally to signal that the session was busy
                if (response.status === 409 || response.status === 502 || response.status === 503 || response.status === 0 || textStatus === "timeout") {
                    var requestTime = window.performance.now() - this._lastStartTime;
                    var waitBeforeRetry = Math.max($dyn.serverForm.maxWaitTimeToRetry - requestTime, 0);
                    // For now we log only this event due to potentially high volume of other events
                    if (response.status !== 409) {
                        $dyn.telemetry.addCommunicationEvent(textStatus, response.status, waitBeforeRetry, 0, $dyn.browserActivity.BrowserSessionActivity.Id, response.readyState);
                    }
                    var underTimeLimit = window.performance.now() - this._initialStartTime < $dyn.serverForm.maxWaitTimeToFail;
                    // Keep retrying the last request for a certain amount of time before giving up
                    if (this.serverSessionId && underTimeLimit) {
                        $dyn.async.pending.decrement("request failed (retrying)");
                        if (waitBeforeRetry === 0) {
                            this._currentRequest = this.beginRequest(data, true);
                        }
                        else {
                            $dyn.async(function () {
                                _this._currentRequest = _this.beginRequest(data, true);
                            }, waitBeforeRetry, "Server request retry on error");
                        }
                    }
                    else if (response.status === 409) {
                        // Session is still busy, show a message that allows the user to continue waiting/retrying
                        // tslint:disable:object-literal-sort-keys
                        this._showConnectionErrorDialog({
                            ImageName: "Info",
                            Text: $dyn.label("LongOperationDialog_Message"),
                            RetryText: $dyn.label("LongOperationDialog_RetryButtonText"),
                            Callback: function () {
                                if (!_this._isChannelBlocking) {
                                    $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: resending request after server doesn't respond");
                                    _this._isChannelBlocking = true;
                                    $dyn.serverForm.interactionManager.incrementGlobalBlockingFlag(true, "showConnectionErrorDialog:noServerReponse");
                                }
                                _this._currentRequest = _this.beginRequest(data, true);
                                $dyn.serverForm.interactionManager._isClientDisconnected = false;
                            },
                        });
                        // tslint:enable:object-literal-sort-keys
                        $dyn.serverForm.interactionManager._isClientDisconnected = true;
                        this._cleanupAfterRequestError();
                        $dyn.async.pending.decrement("request failed (took too long)");
                        return;
                    }
                    else {
                        this._error(response, textStatus, error);
                    }
                }
                else {
                    this._error(response, textStatus, error);
                }
            };
            ReliableChannel.prototype._showConnectionErrorDialog = function (options) {
                // Shows the connection error dialog
                $dyn.showConnectionErrorDialog(options);
            };
            /**
             * Delegate invoked when a request to the server fails.
             * @param request Failed request
             * @param textStatus Request text status
             * @param error Request encountered exception
             */
            ReliableChannel.prototype._error = function (request, textStatus, error) {
                var reloadClient = function (timeout) {
                    var doRefresh = function () {
                        var builder = new $dyn.util.UrlBuilder();
                        builder.fromLocation(location);
                        var targetURL = builder.absoluteUrl();
                        if ($dyn.browserActivity && $dyn.browserActivity.TimeoutTimestamp > Date.now()) {
                            var bid = $dyn.browserActivity.BrowserSessionActivity.Id;
                            var aid = $dyn.browserActivity.BrowserInteractionActivity.Id;
                            var expirationTimestamp = $dyn.browserActivity.TimeoutTimestamp;
                            builder.query[$dyn.shell.QueryStringKeys.browserActivityKey.toLowerCase()] = bid;
                            builder.query[$dyn.shell.QueryStringKeys.activityKey.toLowerCase()] = aid;
                            builder.query[$dyn.shell.QueryStringKeys.expirationKey.toLowerCase()] = expirationTimestamp;
                            targetURL = builder.absoluteUrl();
                        }
                        location.replace(targetURL);
                    };
                    if (timeout !== undefined && timeout !== null) {
                        // Don't use $dyn.async here since we're leaving Dynamics
                        window.setTimeout(doRefresh, timeout);
                    }
                    else {
                        doRefresh();
                    }
                };
                var errorMessage;
                try {
                    this.pendingResponse = false;
                    if ($dyn.serverForm.sessionTimeoutId) {
                        // When an error occurs then clear the session expiration timer.
                        window.clearTimeout($dyn.serverForm.sessionTimeoutId);
                    }
                    if ($dyn.serverForm._pingTimeoutId) {
                        // When an error occurs then clear the ping timer.
                        window.clearInterval($dyn.serverForm._pingTimeoutId);
                    }
                    var parsedResponseParams = null;
                    try {
                        parsedResponseParams = JSON.parse(request.responseText);
                    }
                    catch (e) {
                        // do nothing
                    }
                    if (this._currentRequest == null) {
                        $dyn.logError && $dyn.logError("current request isn't defined");
                    }
                    else if (textStatus === "timeout") {
                        // AJAX request timed out
                        $dyn.telemetry.handleClientError({}, "ServerForm_ServerTimeout", { statusCode: this._currentRequest.status });
                    }
                    else if (this._currentRequest.status === 403) {
                        $dyn.telemetry.handleClientError({ Text: $dyn.label("ServerForm_UnknownUserError"), showCloseButton: false }, "ServerForm_UnknownUserError", {
                            statusCode: this._currentRequest.status,
                        });
                        var log_out_time_out = 9000;
                        // Don't use $dyn.async here since we're leaving Dynamics
                        window.setTimeout(function () {
                            $dyn.shell.logOut();
                        }, log_out_time_out);
                    }
                    else if (this._currentRequest.status === 400 || this._currentRequest.status === 500) {
                        var errorLabel = void 0;
                        var canReload = false;
                        if (parsedResponseParams) {
                            var errorCode = parsedResponseParams.ErrorCode;
                            if (errorCode !== undefined) {
                                errorMessage = parsedResponseParams.Message;
                                // In case of session timeout, show reload client option
                                if (errorCode === 3) {
                                    canReload = true;
                                    if (!$dyn.serverForm.sessionExpired) {
                                        // The session ended before expected
                                        errorLabel = "ServerForm_SessionEndError";
                                        errorMessage = $dyn.label(errorLabel);
                                    }
                                }
                            }
                            if (parsedResponseParams.DiagnosticMesssage) {
                                $dyn.logError($dyn.format($dyn.label("ServerForm_DiagnosticsMessage"), errorMessage, parsedResponseParams.DiagnosticMesssage));
                            }
                        }
                        if (!errorMessage || errorMessage.length === 0) {
                            // Show a generic error if we didn't receive one from server
                            errorLabel = "ServerForm_InternalError";
                            errorMessage = $dyn.label(errorLabel);
                        }
                        $dyn.telemetry.handleClientError({ Text: errorMessage, showCloseButton: canReload, callback: reloadClient }, errorLabel, { statusCode: this._currentRequest.status });
                    }
                    else if (this._currentRequest.status === 503 || this._currentRequest.status === 0) {
                        var reload_client_time_out = 30000;
                        if (!$dyn.shell.IsUnloading) {
                            // error, show message immediately
                            $dyn.telemetry.handleClientError({}, "ServerForm_LostConnection", { statusCode: this._currentRequest.status });
                            reloadClient(reload_client_time_out);
                        }
                        else {
                            // else page is being reloaded,do nothing
                            this._currentRequest = null;
                            window.setTimeout(function () {
                                $dyn.isPageBeingRefreshed = false;
                            }, 30000);
                            return;
                        }
                    }
                    else if (this._currentRequest.status === 401) {
                        // Unauthenticated
                        // Should redirect to force the user to login since we are unauthenticated
                        $dyn.shell.logOut();
                    }
                    else {
                        $dyn.telemetry.handleClientError({}, "ServerForm_GenericError", { statusCode: this._currentRequest.status });
                    }
                    // Unblock the user interaction at this point and restore focus
                    $dyn.shell.forceUnBlockUserInteraction();
                    // Notify the shell to set the isShellInitializing to false, which will allow layout and other things to run
                    // that were postponed due to the splash screen and theme loading.
                    $dyn.shell.isShellInitializing(false);
                    this._currentRequest = null;
                    this._initialStartTime = null;
                }
                finally {
                    $dyn.async.pending.decrement("complete request (error)");
                    this.errorReceived.raise({ Channel: this, Message: errorMessage });
                }
            };
            /**
             * Removes all the Messages from the outbound queue that have sequence number less than or equals to the last server acknowledged one.
             * @returns A list of callbacks
             */
            ReliableChannel.prototype._updateOutboundQueue = function () {
                var interactionCallbacks = [];
                // Remove all the items that the client already acknowledged
                while (this.outboundMessages.length > 0 && this.outboundMessages[0].SequenceNumber <= this.lastServerAcknowledgedSequenceNumber) {
                    var message = this.outboundMessages[0];
                    for (var i = 0, len = message.Interactions.length; i < len; i++) {
                        var interaction = message.Interactions[i];
                        if (interaction.completeCommand || interaction.decrementWindowAsyncPending || interaction.ShouldBlockOnExecution) {
                            interactionCallbacks.push(interaction);
                        }
                        if ($dyn.ui.PerformanceTimer && interaction.$type !== "EventDataInteraction") {
                            $dyn.ui.PerformanceTimer._addAction(interaction.CommandName || interaction.$type);
                        }
                    }
                    // Pops the first item
                    this.outboundMessages.shift();
                }
                return interactionCallbacks;
            };
            ReliableChannel.prototype._assertSequenceNumberNotUsed = function (sequenceNumber) {
                for (var i = 0, len = this.inboundMessages.length; i < len; i++) {
                    if (this.inboundMessages[i].SequenceNumber === sequenceNumber) {
                        $dyn.assert(false, "Message with the same sequence number already exists in the inbound queue.");
                        return;
                    }
                }
            };
            /**
             * Adds a message to the inbound queue. The messages are ordered by their sequence number.
             * @param message Message to add to the inbound message list.
             */
            ReliableChannel.prototype._addToInboundQueue = function (message) {
                $dyn.assert(message, "Message cannot be null.");
                // The list should not have any item with the same sequence number
                if ($dyn.debug.serverForm) {
                    this._assertSequenceNumberNotUsed(message.SequenceNumber);
                }
                // messages should be inserted based on their sequence number
                var count = this.inboundMessages.length;
                // Insert at end if the list is empty or the sequence number of the last message is smaller than the one
                // we are inserting. Normally we should just be inserting at the end
                // unless something happens over the wire and the messages arrive in the wrong order
                if (count === 0 || this.inboundMessages[count - 1].SequenceNumber < message.SequenceNumber) {
                    this.inboundMessages.push(message);
                    return;
                }
                else if (this.inboundMessages[0].SequenceNumber > message.SequenceNumber) {
                    // the first item has a larger sequence number so insert at the beginning
                    this.inboundMessages.unshift(message);
                    return;
                }
                // At this point we better have more than 2 items in the list otherwise the logic above is busted.
                $dyn.assert(count > 2, "Something wrong with the boundary insertion logic.");
                // Loop over the elements in the reverse order, don't do the first and last messages as we have checked
                // them above
                for (var i = count - 1; i > 0; i--) {
                    var currentSequenceNumber = this.inboundMessages[i].SequenceNumber;
                    if (currentSequenceNumber < message.SequenceNumber) {
                        // Insert at i+1
                        this.inboundMessages.splice(i + 1, 0, message);
                        return;
                    }
                    else if (currentSequenceNumber === message.SequenceNumber) {
                        // This can happen if the MessageSet contains multiple messages with the same
                        // Sequence number. This is not good
                        // todo
                        // hook to the error handling system on the client
                        throw new Error("Duplicate sequence number");
                    }
                }
                $dyn.assert(false, "This statement should not be reached.");
            };
            ReliableChannel.serviceAddress = "Services/ReliableCommunicationManager.svc/ProcessMessages";
            return ReliableChannel;
        }());
        serverForm.ReliableChannel = ReliableChannel;
        // tslint:disable-next-line:no-string-literal
        ReliableChannel.prototype["_serverRequestTask"] = new $dyn.PerformanceTask("serverRequest", true);
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ReliableChannel.js.map
